import React from "react";
import Footer from "../../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <div id="privacy" style={{ padding: "20px" }}>
        <header
          style={{
            color: "#0c0c0d",
            textAlign: "center",
            fontSize: "40px",
            fontWeight: "bold",
            marginBottom: "60px",
          }}
        >
          Privacy Policy
        </header>

        <p>
          At Consumer Protection Networks, we prioritize the security and
          confidentiality of your information. We provide legal title transfer
          services for timeshare owners. We do not sell, rent, or share any
          personal data provided to us with third parties or affiliates. Your
          privacy matters to us, and we are committed to safeguarding it at all
          times.
        </p>

        <h2>Information Collection:</h2>
        <p>
          We may collect personal information from you when you visit our
          website, register for an account, request our services, or interact
          with our platform. This information may include your name, email
          address, phone number, and details about your timeshare contract. Data
          may be collected through forms, cookies, or other tracking
          technologies.
        </p>

        <h2>How We Use Your Information:</h2>
        <p>
          We use the information we collect to provide and improve our timeshare
          exit services, process your requests, communicate with you about your
          case, and personalize your experience. We may also use your
          information to send you important updates about your case and other
          relevant communications.
        </p>

        <h2>Data Security:</h2>
        <p>
          We implement robust security measures to protect your personal
          information and maintain its confidentiality. We use industry-standard
          encryption protocols to secure data transmission and storage. We also
          strictly adhere to relevant data protection regulations and standards.
        </p>

        <h2>SMS Communications:</h2>
        <p>
          Text messaging is optional. Providing us with your mobile number does
          not by itself opt you in to text messages, and consent to receive them
          is never a condition of booking an appointment or of using our
          services.
        </p>

        <p>
          You opt in only by actively checking an SMS consent box, which is
          unchecked by default. There are two consent boxes, in each of two
          places: the chat widget on this website, and our appointment booking
          form. The two boxes are separate and you may check either, both, or
          neither.
        </p>

        <p>
          The first box covers messages about your appointment and your case:
          confirmations, reminders, rescheduling notices, service and case
          updates, and replies relating to an enquiry you have already made. The
          second box covers promotional and marketing messages, such as new
          event dates near you and offers on our services. Checking the first
          box does not opt you in to the second. We keep a record of each opt-in
          separately, including the date and time and the exact wording shown to
          you at that moment.
        </p>

        <p>
          Message frequency varies. Message and data rates may apply.
        </p>

        <p>
          You can stop the messages at any time by replying "STOP" to any
          message you receive from us. We will send one confirmation, after
          which you will receive no further text messages. To start receiving
          them again, opt in as you did the first time. Opting out of text
          messages does not stop us contacting you by email or telephone about
          an appointment you have booked.
        </p>

        <p>
          For help with our messaging program, reply "HELP" to any message or
          contact us directly at{" "}
          <a href="mailto:clientservices@consumerprotectionnetworks.com">
            clientservices@consumerprotectionnetworks.com
          </a>
          .
        </p>

        <p>
          <strong>
            No mobile information will be shared with third parties or
            affiliates for marketing or promotional purposes. All the above
            categories exclude text messaging originator opt-in data and
            consent; this information will not be shared with any third parties.
          </strong>
        </p>

        <p>
          The only exception is the messaging providers and aggregators who
          carry the messages to your phone on our behalf, who receive your
          mobile number solely in order to deliver them. They do not receive
          your opt-in data or consent record for any purpose of their own, and
          neither they nor anyone else receives that information for marketing
          or promotional use.
        </p>

        <p>
          Please note that carriers are not liable for delayed or undelivered
          messages. For questions about your text plan or data plan, please
          contact your wireless provider.
        </p>

        <h2>Updates to Privacy Policy:</h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any
          time. Any changes will be reflected on this page. We will notify you
          of significant changes through email or by posting a notice on our
          website. By using our services, you acknowledge that you have read and
          agree to these terms.
        </p>

        <p>
          This Privacy Policy should be read together with our{" "}
          <a href="/Terms">Terms of Service</a>.
        </p>

        <p>
          If you have any questions or concerns about our Privacy Policy or
          practices, please contact us at{" "}
          <a href="mailto:clientservices@consumerprotectionnetworks.com">
            clientservices@consumerprotectionnetworks.com
          </a>{" "}
        </p>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
